import React from "react"
import { Menu } from "react-feather"
import { DeployableContainer } from "../deployableContainer"
import { AppRouter } from "../appRouter"
import { useState } from "react"


const nav_img = (
  <div >
    <Menu size={32}/>
  </div>
) 
export function AppContainer({ children}){

  //stupidity for now
  const [scrollCallback, setScrollCallback] = useState(()=>()=>{})
  // const diagnostics = useDiagnosticsContext()
  

  return (
    <>
      {/* Global backdrop that activates when any chat is open */}
    
      <DeployableContainer
        navImg={nav_img}
        scrollCallback={scrollCallback}
      >
          <AppRouter setScrollCallback={setScrollCallback}/>
      </DeployableContainer>
      <div className="chat-backdrop-global" />

    </>
  )
}